import React from "react";
import { Grid, useMediaQuery, useTheme } from "@mui/material";
import NavLink from "./NavLink";
import { useLocation } from "react-router";

const NavBar = (props) => {
  const { navLinks, showIcons } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const currLocation = useLocation();

  // Mobile: a fixed row of equal-width tabs (icon over short label) that all fit
  // on screen — no horizontal scrolling, so no destination (e.g. Picks) is ever
  // hidden off the edge. Each NavLink takes flex:1, so the six tabs divide the
  // width evenly.
  if (isMobile) {
    return (
      <Grid
        container
        direction="row"
        wrap="nowrap"
        sx={{
          width: "100%",
          justifyContent: "space-between",
          alignItems: "stretch",
        }}
      >
        {navLinks.map((item) => (
          <NavLink
            key={`nav-link-${item.title.toLowerCase()}`}
            href={item.href}
            title={item.title}
            mobileTitle={item.mobileTitle}
            icon={item.icon}
            active={currLocation.pathname.includes(item.hrefRoot || item.href)}
            addLive={item.addLive}
            showIcons={showIcons}
          />
        ))}
      </Grid>
    );
  }

  return (
    <Grid
      container
      direction="column"
      sx={{ position: "relative", width: "100%" }}
    >
      <Grid
        container
        direction="column"
        sx={{
          position: "relative",
          width: "fit-content",
          maxWidth: "100%",
          overflow: "scroll",
          scrollbarWidth: "none",
        }}
      >
        <Grid
          container
          direction="row"
          wrap="nowrap"
          sx={{
            position: "relative",
            overflow: "scroll",
            whiteSpace: "nowrap",
            scrollbarWidth: "none",
          }}
        >
          {navLinks.map((item) => (
            <NavLink
              key={`nav-link-${item.title.toLowerCase()}`}
              href={item.href}
              title={item.title}
              icon={item.icon}
              active={currLocation.pathname.includes(
                item.hrefRoot || item.href,
              )}
              addLive={item.addLive}
              showIcons={showIcons}
            />
          ))}
        </Grid>
        {/* active tab indicator */}
        <Grid
          sx={{
            position: "absolute",
            bottom: 0,
            height: "2px",
            width: "100%",
            background: `linear-gradient(90deg, ${theme.branding.cyan[200]} 0%, ${theme.branding.cyan[700]} 100%);`,
            transition: "all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
          }}
        />
      </Grid>
    </Grid>
  );
};

export default NavBar;
